import { mapState } from 'vuex';

export default {
	data() {
		return {
			isShowUnmaskData: false,
		};
	},
	computed: {
		...mapState('profile', {
			permissions: 'permissions',
		}),

		/**
		 * Determines if the user has edit permission based on the current route's permission key.
		 * @returns {boolean} True if the user has edit permission, false otherwise.
		 */
		hasEditPermission() {
			const routePermissionKey = this.$route.meta?.routePermissionKey;
			const permissionKey = Array.isArray(routePermissionKey) ? routePermissionKey[0] : routePermissionKey;
			const userPermission = this.permissions?.find((permission) => permission.key === permissionKey);
			return userPermission?.permissions?.manage ?? false;
		},

		/**
		 * Determines if the user has view permission based on the current route's permission key.
		 * @returns {boolean} True if the user has view permission, false otherwise.
		 */
		hasViewPermission() {
			const routePermissionKey = this.$route.meta?.routePermissionKey;
			const permissionKey = Array.isArray(routePermissionKey) ? routePermissionKey[0] : routePermissionKey;
			const permission = this.permissions?.find((p) => p.key === permissionKey);
			return permission?.permissions?.view ?? false;
		},

		/**
		 * Determines if the user has import permission based on the current route's permission key.
		 * @returns {boolean} True if the user has import permission, false otherwise.
		 */
		hasImportPermission() {
			const routePermissionKey = this.$route.meta?.routePermissionKey;
			const permissionKey = Array.isArray(routePermissionKey) ? routePermissionKey[0] : routePermissionKey;
			const permission = this.permissions?.find((p) => p.key === permissionKey);
			return permission?.permissions?.import ?? false;
		},

		/**
		 * Determines if the user has export permission based on the current route's permission key.
		 * @returns {boolean} True if the user has export permission, false otherwise.
		 */
		hasExportPermission() {
			const routePermissionKey = this.$route.meta?.routePermissionKey;
			const permissionKey = Array.isArray(routePermissionKey) ? routePermissionKey[0] : routePermissionKey;
			const permission = this.permissions?.find((p) => p.key === permissionKey);
			return permission?.permissions?.export ?? false;
		},

		/**
		 * Checks if any string in the array contains the character "***".
		 * @param {Array<string>} arr The input array of strings.
		 * @returns {boolean} True if any string contains "***", false otherwise.
		 */
		hasWildcardInProps() {
			return Object.keys(this.$props).some((propKey) => {
				const propValue = this.$props[propKey];

				if (typeof propValue !== 'string') {
					return false;
				}

				try {
					return this.hasWildcard([propValue]);
				} catch (error) {
					// eslint-disable-next-line
					console.error('Error occurred while checking for wildcard in props', error);

					return false;
				}
			});
		},

		/**
		 * Checks if the current query mode is 'edit'.
		 * @returns {boolean} True if the query mode is 'edit', false otherwise.
		 */
		isQueryModeEdit() {
			const queryMode = this.$route.query?.mode;
			return queryMode !== null && queryMode !== undefined && String(queryMode) === 'edit';
		},
	},

	methods: {
		/**
		 * Checks if any string in the array contains the character "***".
		 * @param {Array<string>} arr The input array of strings.
		 * @returns {boolean} True if any string contains "***", false otherwise.
		 */
		hasWildcard(arr) {
			return arr.some((str) => str.includes('***'));
		},

		/**
		 * Updates the current route's query parameters to set the mode to 'edit'.
		 */
		updateQueryModeToEdit() {
			this.$router.push({ query: { ...this.$route.query, mode: 'edit' } });
		},
	},
};
